
export enum ProductCategoryEnum {
  INSURANCE = 'insuranceCategory',
  MORTGAGE_LOAN = 'mortgageLoanCategory',
  INVESTMENT = 'investmentCategory',
  NON_BANK = 'nonBankCategory',
  SME = 'smeCategory',
  REAL_ESTATE = 'realEstateCategory',
  CASH_LOAN = 'cashLoanCategory'
}